import { Button } from "@/components/ui/button";
import useDesignSystemStore, {
  GenerationStatus,
} from "@/store/zustand/aiDesignSystemBuilder";
import useGenerateOverview from "../hooks/useGenerateOverview";
import useGenerateStory from "../hooks/useGenerateStory";
import React, { useCallback } from "react";

interface Action {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

const GenerationActions = () => {
  const {
    status,
    context: { examples, selectedFiles },
  } = useDesignSystemStore((state) => state.generation);

  const { generateOverview } = useGenerateOverview();
  const { generateStory } = useGenerateStory();

  const contextSelected = examples.length > 0 || selectedFiles.length > 0;

  const handleGenerateOverview = useCallback(() => {
    generateOverview();
  }, [generateOverview]);

  const handleGenerateStory = useCallback(() => {
    generateStory();
  }, [generateStory]);

  const actions: Action[] = [];

  switch (status) {
    case GenerationStatus.ContextSelection:
      if (contextSelected) {
        actions.push({
          label: "Generate Overview",
          onClick: handleGenerateOverview,
        });
      }
      break;
    case GenerationStatus.Editing:
      actions.push({
        label: "Generate Story",
        onClick: handleGenerateStory,
      });
      break;
    case GenerationStatus.WaitingForUserAction:
      actions.push({
        label: "Regenerate Story",
        onClick: handleGenerateStory,
      });
      break;
  }

  if (!actions.length) {
    return null;
  }

  return (
    <div className="bg-secondary-0 h-8 sticky bottom-0">
      <div className="flex flex-row gap-4 w-full">
        {actions.map((action, index) => (
          <Button
            key={index}
            variant="primary"
            size="sm"
            onClick={action.onClick}
            disabled={action.disabled}
          >
            {action.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default React.memo(GenerationActions);
